<template>
	<div class="container">
		<h4>Lista de Videos</h4>
	       <ul class="list-group">
	        <li class="list-group-item" 
	          v-for="(video,indice) in videos" 
	          v-bind:class=" { noVisible: !(video.visible) }">
	          
	          {{ video.nombre }}
	          
	          <button data-toggle="tooltip" title="Eliminar"
	            type="button" 
	            class="btn btn-danger btn-md btn-style glyphicon glyphicon-floppy-remove pull-right btn-admin"
	            v-on:click="eliminarVideo(indice)">
	          </button>

	          <button data-toggle="tooltip" title="Ocultar / Desocultar" 
	            type="button" 
	            class="btn btn-success btn-md btn-style glyphicon glyphicon-ok pull-right btn-admin" 
	            v-on:click="estado(video,indice)">
	          </button>
	        
	        </li>
	    </ul>
	</div>
</template>
<script>
	export default{
		
		props:['videos'],
		methods:{
			estado : function(v,index){

		        let visible = this.videos[index].visible = !this.videos[index].visible;

		        let id = this.videos[index].id;

		        this.$http.patch('videos-adn/' + id + '.json',{
		          visible : visible}).then(respuesta => {console.log(respuesta)})
		        },

			eliminarVideo : function(index){
				let id = this.videos[index].id;
				this.videos.splice(index,1);

				this.$http.delete('videos-adn/' + id + '.json')
				.then(respuesta => {console.log(respuesta)})
			}
			
		}
	}
</script>


// WEBPACK FOOTER //
// src/ListaVideosComponent.vue